export interface RenderTree {
  id: string;
  name: string;
  children?: RenderTree[];
}

interface ExtendedRenderTree extends RenderTree {
  hasCh?: boolean; 
}
export const findNodeById = (node: ExtendedRenderTree, id: string): ExtendedRenderTree | null => {
  if (node.id === id) return node;
  if (node && node.children) {
    for (const child of node.children) {
      const result = findNodeById(child, id);
      if (result) return result;
    }
  }
  return null;
};

export const findChildrenById = (node: RenderTree, id: string): RenderTree | null => {
  if (node.id === id) {
    return {
      ...node,
      children: node.children || []
    };
  }

  if (node && node.children) {
    for (const child of node.children) {
      const result = findChildrenById(child, id);
      if (result) {
        return result;
      }
    }
  }

  return null;
};

export const findChildrenByName = (node: RenderTree, name: string): RenderTree | null => {
  if (node?.name === name) {
    return {
      ...node,
      children: node.children || []
    };
  }

  if (node && node?.children) {
    for (const child of node.children) {
      const result = findChildrenByName(child, name);
      if (result) {
        return result;
      }
    }
  }

  return null;
};

export const updateNodeInTree = (node: RenderTree, id: string, changes: Partial<RenderTree>): RenderTree => {
  // If the current node matches the id, apply the changes.
  if (node.id === id) {
    return { ...node, ...changes };
  }

  // If the node has children, recursively update them.
  if (node.children) {
    return {
      ...node,
      children: node.children.map(child => updateNodeInTree(child, id, changes))
    };
  }

  // If no match and no children, return the node unchanged.
  return node;
};

export const findAncestors = (node: RenderTree, targetId: string, path: RenderTree[] = []): RenderTree[] | null => {
  if (node?.id === targetId) {
    return [...path, node];
  }

  if (node?.children) {
    for (const child of node.children) {
      const result = findAncestors(child, targetId, [...path, node]);
      if (result) return result;
    }
  }

  return null;
};

